import YesIcon from 'assets/images/yes-icon.svg';
import SuccessImage from 'assets/images/create-success.svg';
import CancelRenewalImage from 'assets/images/cancel-renewal-v2.svg';
import CanceSubslImage from 'assets/images/sad-smiley.svg';
import ThumbsupImage from 'assets/images/thumbsup-smiley.svg';
import Logo from 'assets/images/logo.svg';
import FooterLogo from 'assets/images/logo-footer.svg';
import Theme from 'theme';

const {
  REACT_APP_GROUP_ID: groupId,
  REACT_APP_AWS_REGION: region,
  REACT_APP_COGNITO_POOL_ID: userPoolId,
  REACT_APP_COGNITO_WEB_CLIENT_ID: userPoolWebClientId,
  REACT_APP_CLIENT_HEADER: clientHeader = groupId,
  REACT_APP_BLOG_STRAPI_URL: blogStrapiUrl,
  REACT_APP_BLOG_STRAPI_API_TOKEN: blogStrapiApiToken,
  REACT_APP_BLOG_STRAPI_STATUS: blogStrapiStatus,
} = process.env;

const config = {
  groupId,
  region,
  userPoolId,
  userPoolWebClientId,
  logo: Logo,
  cptCodesIcon: YesIcon,
  portalName: 'smartyplans consumer portal',
  // Industry drives the Strapi FAQ template (SAP-7671). Omit to default to 'dental'.
  // Valid: dental | primary-care | chiropractic | dermatology | urgent-care | veterinary
  industry: 'dental',
  tokenName: 'smartyplansconsumerportalSubscriberToken',
  globalClass: 'smartyplans-consumer-portal-container',
  clientHeader,
  blogSource: {
    strapiUrl: blogStrapiUrl,
    apiToken: blogStrapiApiToken,
    status: blogStrapiStatus,
  },
  faqSource: {
    strapiUrl: blogStrapiUrl,
    apiToken: blogStrapiApiToken,
    status: blogStrapiStatus,
  },
  enableHeroButton: true,
  pricingType: 'standard-pricing',
  heroLocaleColor: 'secondary',
  splitPlans: false,
  plansPage: {
    enable: true,
    heroImages: {
      blob: '/images/plans/hero-blob.svg',
      character: '/images/plans/hero-monkey.png',
    },
    planCardIcons: [
      '/images/plans/icon-wellness.svg',
      '/images/plans/icon-dental.svg',
    ],
    checkIcon: '/images/plans/check.svg',
    planButtonProps: { to: '/choose-plan' },
    combinedPrice: { enable: true, dependentAsTotal: true },
    highlightsSection: {
      enable: true,
      icons: [
        '/images/plans/icon-family.svg',
        '/images/plans/icon-nationwide.svg',
        '/images/plans/icon-bundle.svg',
        '/images/plans/icon-mobile.svg',
      ],
      noteImage: '/images/plans/card-monkey.png',
    },
    comparisonSection: {
      enable: true,
      rowIcons: [
        '/images/plans/row-dental.svg',
        '/images/plans/row-vision.svg',
        '/images/plans/row-hearing.svg',
        '/images/plans/row-price.svg',
        '/images/plans/row-price.svg',
        '/images/plans/row-who.svg',
      ],
      includedIcon: '/images/plans/yes.svg',
      excludedIcon: '/images/plans/no.svg',
    },
    faqSection: {
      enable: true,
      variant: 3,
    },
    ctaSection: {
      enable: true,
      image: '/images/about/about-cta-image.png',
      imageAlt: 'SmartyPlan monkey dancing with headphones',
      primaryButtonIcon: '/images/benefits-pages/arrow-right.svg',
      primaryButtonProps: { to: '/choose-plan' },
    },
    contactCardSection: { enable: true },
  },
  headerProps: {
    enable: true,
    showLogin: false,
    signupButtonFlow: 'subscription',
    buttonProps: {
      enable: true,
      to: '/choose-plan',
    },
    secondaryButtonProps: {
      enable: true,
      to: '/login',
    },
  },
  homeTemplateProps: {
    heroSection: {
      variant: 3,
      preTitleClasses: 'home-hero-pretitle',
      titleClasses: 'home-hero-title',
      subTitleClasses: 'home-hero-subtitle',
      showSubtitleDivider: true,
      primaryButtonProps: {
        to: '/choose-plan',
      },
      secondaryButtonProps: {
        to: '/login',
        color: 'primary',
      },
      heroImage: '/images/home-images/home-banner-img.webp',
      showPartnerLogos: true,
      partnerLogos: [
        {
          src: '/images/home-images/hero-partner-logos.png',
          alt: 'Teledentistry, Audicus, United Vision Plan and Cigna Healthcare',
        },
      ],
    },
    benefitsSection: {
      enable: true,
      variant: 1,
      definitionPosition: 'bottom',
    },
    membershipValueSection: {
      enable: true,
      variant: 1,
      position: 'top',
      heroImage: '/images/home-images/membership-value/membership-center-image.png',
      heroImageAlt: 'SmartyPlan membership value preview',
      heroImageLink: '/choose-plan',
      backgroundImages: [],
      arrowImages: {
        line: '/images/home-images/membership-value/arrow-line.svg',
      },
    },
    subscriptionSection: {
      priority: 'top',
      tabVariant: 2,
      cardVariant: 7,
      preTitle: 'WHY SMARTYPLAN?',
      carouselResponsiveItems: {
        desktop: 3,
      },
      showAddons: false,
      primaryButtonProps: {
        color: 'primary',
      },
      planCardProps: {
        selectButton: { enable: true },
        combinedPrice: { enable: true, dependentAsTotal: true, dependentNote: true },
      },
    },
    howItWorksSection: {
      enable: true,
      variant: 2,
      alignTitle: 'left',
      heroImage: '/images/home-images/how-it-works.svg',
      customNavPath: '/choose-plan',
    },
    testimonialSection: {
      enable: false
    },
    staticHeroSection: {
      enable: false
    },
    contactSection: {
      enable: true
    },
    partnersSection: {
      enable: true,
      items: [
        {
          icon: '/images/about/about-partners/about-partner-1.svg',
          iconAlt: 'Dental partner icon',
          link: 'https://www.teledentistry.com',
          target: '_blank',
        },
        {
          icon: '/images/about/about-partners/about-partner-2.svg',
          iconAlt: 'Hearing partner icon',
          link: 'https://www.audicus.com/partners/smartyplan/',
          target: '_blank',
        },
        {
          icon: '/images/about/about-partners/about-partner-3.svg',
          iconAlt: 'Vision partner icon',
          link: 'https://www.unitedvisionplan.com/',
          target: '_blank',
        },
      ],
    },
    faqSection: {
      enable: true,
      variant: 3,
    },
    blogSection: {
      enable: true,
      limit: 4,
      ctaProps: { to: '/blogs' },
    },
  },
  checkoutSection: {},
  findProviderSection: {
    locationWrapper: 6,
    mapWrapper: 6,
    showLabelsAsPlaceholders: true,
  },
  choosePlanSection: {
    sectionSubtitle: '',
    locationLogo: Logo,
    cardVariant: 6,
    tabVariant: 2,
    planCardProps: {
      combinedPrice: { enable: true, dependentAsTotal: true, dependentNote: true },
      buttonProps: {
        normalColor: 'primary',
        highlightedColor: 'primary',
        normalVariant: 'contained',
        highlightedVariant: 'outlined',
      },
      highlightsByPlan: {
        'Complete Wellness': [
          { icon: '/images/home-images/plan-highlights/plan-highlights-1.png' },
          { icon: '/images/home-images/plan-highlights/plan-highlights-2.png' },
          { icon: '/images/home-images/plan-highlights/plan-highlights-3.png' },
        ],
        'Smarty Plan Dental': [
          { icon: '/images/home-images/plan-highlights/plan-highlights-4.png' },
          { icon: '/images/home-images/plan-highlights/plan-highlights-5.png' },
          { icon: '/images/home-images/plan-highlights/plan-highlights-6.png' },
        ],
      },
    },
    staticHeroSection: {
      enable: false,
      variant: 1,
    },
  },
  subscriptionSuccess: {
    successImage: SuccessImage,
    enableBookAppointment: false,
    secondaryButtonProps: {
      variant: 'outlined',
      color: 'primary',
    },
  },
  savingsSummary: {
     contactSection: 'contactDetails'
  },
  dashboardProps: {
    showBenefitsUsage: false,
    cancelRenewal: {
      image: CancelRenewalImage,
    },
    cancelSubscription: {
      image: CanceSubslImage,
    },
    reactivateRenewal: {
      image: ThumbsupImage,
    },
    haveQuestionsPartnerLinks: {
      enable: false,
      prefix: 'Visit our partners',
      items: [
        {
          label: 'Audicus',
          link: 'https://www.audicus.com/partners/smartyplan/',
          target: '_blank',
        },
        {
          label: 'United Vision Plan',
          link: 'https://www.unitedvisionplan.com/',
          target: '_blank',
        },
      ],
    },
    partnersSection: {
      enable: true,
      title: 'Access Your Benefits',
      pretitle: '',
      subtitle: '',
      items: [
        {
          icon: '/images/about/about-partners/about-partner-1.svg',
          iconAlt: 'Dental partner icon',
          link: 'https://www.teledentistry.com/smartyplan',
          target: '_blank',
        },
        {
          icon: '/images/about/about-partners/about-partner-2.svg',
          iconAlt: 'Hearing partner icon',
          link: 'https://www.audicus.com/partners/smartyplan/',
          target: '_blank',
        },
        {
          icon: '/images/about/about-partners/about-partner-3.svg',
          iconAlt: 'Vision partner icon',
          link: 'https://www.unitedvisionplan.com/',
          target: '_blank',
        },
      ],
    },
  },
  bookAppointment: {},
  footer: {
    enable: true,
    logo: FooterLogo,
    enableFAQs: false,
  },
  aboutPage: {
    heroImage: '/images/about/about-hero.png',
    heroImageAlt: 'SmartyPlan monkey waving',
    primaryButtonProps: {
      to: '/choose-plan',
    },
    primaryButtonIcon: '/images/benefits-pages/arrow-right.svg',
    secondaryButtonProps: {
      to: '/plans',
    },
    benefitsSection: {
      enable: true,
      variant: 1,
      items: [
        {
          icon: '/images/about/benefits/icon-1.svg',
          iconAlt: 'Simple membership icon',
        },
        {
          icon: '/images/about/benefits/icon-2.svg',
          iconAlt: 'Dental hearing vision icon',
        },
        {
          icon: '/images/about/benefits/icon-3.svg',
          iconAlt: 'Family friendly icon',
        },
        {
          icon: '/images/about/benefits/icon-4.svg',
          iconAlt: 'Nationwide convenience icon',
        },
      ],
    },
    missionSection: {
      enable: true,
      items: [
        { icon: '/images/about/mission/icon-1.svg' },
        { icon: '/images/about/mission/icon-2.svg' },
        { icon: '/images/about/mission/icon-3.svg' },
      ],
    },
    partnersSection: {
      enable: true,
      variant: 1,
      items: [
        {
          icon: '/images/about/about-partners/about-partner-1.svg',
          iconAlt: 'Dental partner icon',
          link: 'https://www.teledentistry.com',
          target: '_blank',
        },
        {
          icon: '/images/about/about-partners/about-partner-2.svg',
          iconAlt: 'Hearing partner icon',
          link: 'https://www.audicus.com/partners/smartyplan/',
          target: '_blank',
        },
        {
          icon: '/images/about/about-partners/about-partner-3.svg',
          iconAlt: 'Vision partner icon',
          link: 'https://www.unitedvisionplan.com/',
          target: '_blank',
        },
      ],
    },
    serviceSection: {
      enable: true,
      noteIcon: '/images/about/about-service/about-service-note-icon.png',
      items: [
        { image: '/images/about/about-service/about-service-1.png' },
        { image: '/images/about/about-service/about-service-2.png' },
        { image: '/images/about/about-service/about-service-3.png' },
        { image: '/images/about/about-service/about-service-4.png' },
        { image: '/images/about/about-service/about-service-5.png' },
        { image: '/images/about/about-service/about-service-6.png' },
      ],
    },
    howItWorksSection: {
      enable: true,
      variant: 7,
      padStepNumbers: true,
      badgePosition: 'top',
      stepMarker: 'number',
      groups: [
        {
          stepCount: 1,
          image: '/images/benefits-pages/join.png',
          imageAlt: 'SmartyPlan create account screen',
        },
        {
          stepCount: 2,
          image: '/images/about/about-how-it-works/about.png',
          imageAlt: 'SmartyPlan member benefits screen',
        },
      ],
    },
    infoSection: {
      enable: true,
      items: [
        { icon: '/images/about/about-info/about-info-1.png' },
        { icon: '/images/about/about-info/about-info-2.png' },
        { icon: '/images/about/about-info/about-info-3.png' },
      ],
    },
    aboutCtaSection: {
      enable: true,
      image: '/images/about/about-cta-image.png',
      imageAlt: 'SmartyPlan monkey dancing with headphones',
      primaryButtonIcon: '/images/benefits-pages/arrow-right.svg',
      primaryButtonProps: { to: '/choose-plan' },
      secondaryButtonProps: { to: '/#benefits' },
    },
    faqSection: {
      enable: true,
      variant: 3,
    },
    contactCardSection: {
      enable: true,
      variant: 1,
      items: [
        {
          icon: '/images/contact-card/phone.svg',
          link: 'tel:(844)969-1001',
        },
        {
          icon: '/images/contact-card/mail.svg',
          link: 'mailto:care@smartyplan.com',
        },
        {
          icon: '/images/contact-card/clock.svg',
        },
      ],
    },
  },
  dentalPageProps: {
    subscriptionSection: {
      enable: true,
      priority: 'top',
      tabVariant: 2,
      cardVariant: 6,
      carouselResponsiveItems: {
        desktop: 2,
      },
      showAddons: false,
      primaryButtonProps: {
        color: 'primary',
      },
      planCardProps: {
        combinedPrice: { enable: true, dependentAsTotal: true, dependentNote: true },
      },
    },
    howItWorksSection: {
      enable: true,
      variant: 7,
      padStepNumbers: true,
      sectionClass: 'benefit-howitworks',
      groups: [
        {
          stepCount: 1,
          image: '/images/benefits-pages/page-1/how-it-works-1/image.png',
          imageAlt: 'SmartyPlan create account screen',
        },
        {
          stepCount: 2,
          image: '/images/benefits-pages/page-1/how-it-works-2/image.png',
          imageAlt: 'SmartyPlan member benefits screen',
        },
      ],
    },
  },
  visionPageProps: {
    howItWorksSection: {
      enable: true,
      variant: 7,
      padStepNumbers: true,
      badgePosition: 'top',
      sectionClass: 'benefit-howitworks',
      groups: [
        {
          stepCount: 1,
          image: '/images/benefits-pages/page-2/how-it-works-1/image.png',
          imageAlt: 'SmartyPlan create account screen',
        },
        {
          stepCount: 1,
          image: '/images/benefits-pages/page-2/how-it-works-2/image.png',
          imageAlt: 'SmartyPlan frame browsing screen',
        },
        { stepCount: 1, compact: true, bulletsInline: true },
      ],
    },
  },
  hearingPageProps: {
    howItWorksSection: {
      enable: true,
      variant: 7,
      padStepNumbers: true,
      badgePosition: 'top',
      sectionClass: 'benefit-howitworks',
      groups: [
        {
          stepCount: 1,
          image: '/images/benefits-pages/page-3/how-it-works-1/image.png',
          imageAlt: 'SmartyPlan create account screen',
        },
        {
          stepCount: 1,
          image: '/images/benefits-pages/page-3/how-it-works-2/image.png',
          imageAlt: 'SmartyPlan hearing test screen',
        },
        { stepCount: 2, columns: 2, compact: true },
      ],
    },
  },
  benefitPages: {
    dental: {
      heroImage: '/images/benefits-pages/page-1/hero/image.png',
      heroImageAlt: 'SmartyPlan monkey holding a toothbrush',
      primaryButtonProps: { to: '/choose-plan' },
      primaryButtonIcon: '/images/benefits-pages/arrow-right.svg',
      secondaryButtonProps: { to: '/plans' },
      cards: [
        { icon: '/images/benefits-pages/page-1/hero/icon-1.svg' },
        { icon: '/images/benefits-pages/page-1/hero/icon-2.svg' },
        { icon: '/images/benefits-pages/page-1/hero/icon-3.svg' },
      ],
      cta: {
        enable: true,
        image: '/images/benefits-pages/page-1/cta/image.png',
        imageAlt: 'SmartyPlan monkey brushing its teeth',
        primaryButtonIcon: '/images/benefits-pages/arrow-right.svg',
        primaryButtonProps: { to: '/choose-plan' },
        secondaryButtonProps: { to: '/plans' },
      },
      contact: { enable: true },
      findProviderEmbed: {
        enable: true,
        logo: '/images/benefits-pages/page-1/find-a-provider/logo.png',
        logoAlt: 'Cigna Healthcare',
        src: 'https://smarty-providers.pages.dev/smarty-dentist-finder.js',
        variant: 'compact',
      },
      strips: [
        {
          items: [
            { icon: '/images/benefits-pages/page-1/plan-section-1/icon-1.svg' },
            { icon: '/images/benefits-pages/page-1/plan-section-1/icon-2.svg' },
            { icon: '/images/benefits-pages/page-1/plan-section-1/icon-3.svg' },
            { icon: '/images/benefits-pages/page-1/plan-section-1/icon-4.svg' },
          ],
        },
        {
          items: [
            { icon: '/images/benefits-pages/page-1/plan-section-2/icon-1.svg' },
            { icon: '/images/benefits-pages/page-1/plan-section-2/icon-2.svg' },
            { icon: '/images/benefits-pages/page-1/plan-section-2/icon-3.svg' },
            { icon: '/images/benefits-pages/page-1/plan-section-2/icon-4.svg' },
          ],
        },
      ],
    },
    vision: {
      heroImage: '/images/benefits-pages/page-2/hero/image.png',
      heroImageAlt: 'SmartyPlan monkey wearing glasses',
      primaryButtonProps: { to: '/choose-plan' },
      primaryButtonIcon: '/images/benefits-pages/arrow-right.svg',
      secondaryButtonProps: { to: '/plans' },
      cards: [
        { icon: '/images/benefits-pages/page-2/hero/icon-1.png' },
        { icon: '/images/benefits-pages/page-2/hero/icon-2.png' },
        { icon: '/images/benefits-pages/page-2/hero/icon-3.png' },
      ],
      benefitTable: { enable: true },
      memberValue: {
        enable: true,
        image: '/images/benefits-pages/page-2/member-value/image.png',
        imageAlt: '',
      },
      cta: {
        enable: true,
        image: '/images/benefits-pages/page-2/cta/image.png',
        imageAlt: 'SmartyPlan monkey wearing glasses',
        primaryButtonIcon: '/images/benefits-pages/arrow-right.svg',
        primaryButtonProps: { to: '/choose-plan' },
        secondaryButtonProps: { to: '/plans' },
      },
      contact: { enable: true },
      strips: [
        {
          iconVariant: 'full',
          items: [
            { icon: '/images/benefits-pages/page-2/plan-section-1/icon-1.png' },
            { icon: '/images/benefits-pages/page-2/plan-section-1/icon-2.png' },
            { icon: '/images/benefits-pages/page-2/plan-section-1/icon-3.png' },
            { icon: '/images/benefits-pages/page-2/plan-section-1/icon-4.png' },
          ],
        },
      ],
    },
    hearing: {
      heroImage: '/images/benefits-pages/page-3/hero/image.png',
      heroImageAlt: 'SmartyPlan monkey wearing headphones',
      primaryButtonProps: { to: '/choose-plan' },
      primaryButtonIcon: '/images/benefits-pages/arrow-right.svg',
      secondaryButtonProps: { to: '/plans' },
      cards: [
        { icon: '/images/benefits-pages/page-3/hero/icon-1.svg' },
        { icon: '/images/benefits-pages/page-3/hero/icon-2.svg' },
        { icon: '/images/benefits-pages/page-3/hero/icon-3.svg' },
      ],
      memberValue: {
        enable: true,
        image: '/images/benefits-pages/page-3/member-value/image.png',
        imageAlt: '',
      },
      cta: {
        enable: true,
        image: '/images/benefits-pages/page-3/cta/image.png',
        imageAlt: 'SmartyPlan monkey wearing headphones',
        primaryButtonIcon: '/images/benefits-pages/arrow-right.svg',
        primaryButtonProps: { to: '/choose-plan' },
        secondaryButtonProps: { to: '/plans' },
      },
      contact: { enable: true },
      strips: [
        {
          iconVariant: 'full',
          items: [
            { icon: '/images/benefits-pages/page-3/plan-section-1/icon-1.png' },
            { icon: '/images/benefits-pages/page-3/plan-section-1/icon-2.png' },
            { icon: '/images/benefits-pages/page-3/plan-section-1/icon-3.png' },
            { icon: '/images/benefits-pages/page-3/plan-section-1/icon-4.png' },
          ],
        },
        {
          iconVariant: 'full',
          items: [
            { icon: '/images/benefits-pages/page-3/plan-section-2/icon-1.png' },
            { icon: '/images/benefits-pages/page-3/plan-section-2/icon-2.png' },
            { icon: '/images/benefits-pages/page-3/plan-section-2/icon-3.png' },
            { icon: '/images/benefits-pages/page-3/plan-section-2/icon-4.png' },
          ],
        },
      ],
    },
  },
  howItWorksPage: {
    heroSection: {
      enable: true,
      image: '/images/how-it-works/hero-app.png',
      imageAlt: 'SmartyPlan member app screens',
      imageLink: '/choose-plan',
      connectorImages: {
        edge: '/images/how-it-works/hero-connector-edge.svg',
        middle: '/images/how-it-works/hero-connector-middle.svg',
      },
      features: [
        { icon: '/images/how-it-works/hero-feature-1.png', link: '/choose-plan' },
        { icon: '/images/how-it-works/hero-feature-2.svg', framedIcon: true, link: '/choose-plan' },
      ],
      callouts: [
        { icon: '/images/how-it-works/hero-callout-1.svg' },
        { icon: '/images/how-it-works/hero-callout-2.svg' },
        { icon: '/images/how-it-works/hero-callout-3.svg' },
      ],
    },
    benefitSection: {
      enable: true,
      items: [
        { icon: '/images/how-it-works/benefit-1.svg' },
        { icon: '/images/how-it-works/benefit-2.svg' },
        { icon: '/images/how-it-works/benefit-3.svg' },
        { icon: '/images/how-it-works/benefit-4.svg' },
      ],
    },
    introSection: {
      enable: true,
      primaryButtonIcon: '/images/benefits-pages/arrow-right.svg',
      primaryButtonProps: { to: '/choose-plan' },
      secondaryButtonProps: { to: '/savings-summary' },
    },
    howItWorksSection: {
      enable: true,
      variant: 7,
      padStepNumbers: true,
      badgePosition: 'top',
      stepMarker: 'number',
      groups: [
        {
          stepCount: 1,
          image: '/images/how-it-works/step-1.png',
          imageAlt: 'SmartyPlan create account screen',
        },
        {
          stepCount: 1,
          image: '/images/how-it-works/step-2.png',
          imageAlt: 'SmartyPlan member benefits screen',
        },
        {
          stepCount: 1,
          image: '/images/how-it-works/step-3.png',
          imageAlt: 'SmartyPlan monkey with savings',
        },
      ],
    },
    loveSection: {
      enable: true,
      image: '/images/how-it-works/love-image.png',
      imageAlt: 'SmartyPlan monkey giving a thumbs up',
      items: [
        { icon: '/images/how-it-works/love-1.png' },
        { icon: '/images/how-it-works/love-2.png' },
        { icon: '/images/how-it-works/love-3.png' },
        { icon: '/images/how-it-works/love-4.png' },
      ],
    },
    contactCardSection: {
      enable: true,
      variant: 1,
      items: [
        {
          icon: '/images/contact-card/phone.svg',
          link: 'tel:(844)969-1001',
        },
        {
          icon: '/images/contact-card/mail.svg',
          link: 'mailto:care@smartyplan.com',
        },
        {
          icon: '/images/contact-card/clock.svg',
        },
      ],
    },
  },
  loginPage: {
    bannerImage: './images/login.webp',
  },
  theme: Theme,
};

export default config;
